import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';
import { UserApiService } from '../../services/user-api.service';
import {
  PCTableInputModel,
  PCTableOutputModel,
  PCTableRowButtonModel,
} from '../../models/pc-table-input-model';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { TabelPaging } from '../../interfaces/table';
import {
  PCTableActionInputModel,
  PCTableFieldModel,
} from '../../models/pc-table-action-input-model';
import { DatePipe } from '@angular/common';
import { ModalConfirm } from '../../models/modal-confirm';
import { WarehouseHandlingModal } from '../../models/warehose-handling-modal';
import { WarehouseHandlingReport } from '../../models/warehose-handling-report';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { WarehouseHandlingDetailComponent } from '../warehouse-handling-detail/warehouse-handling-detail.component';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-warehouse-handling-report',
  templateUrl: './warehouse-handling-report.component.html',
  styleUrls: ['./warehouse-handling-report.component.css'],
})
export class WarehouseHandlingReportComponent {
  constructor(
    private modalService: NgbModal,
    private logger: LoggerService,
    private renderer: Renderer2,
    private route: Router,
    public datepipe: DatePipe,
    private database: DataService,
    private responseService: CustomizeResponseService,
    private apiService: UserApiService
  ) {
    this.getStockData();
    this.thisValue = new WarehouseHandlingModal();
    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == '+') {
        this.openAddModal = true;
        this.thisValue = new WarehouseHandlingModal();
      }
    });

    this.requestModel = new PCSearchRequestModel();
    this.requestModel.direction = 'desc';
    this.requestModel.orderBy = 'startDate';

    this.action = new PCTableActionInputModel(
      [
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Print',
          className: 'btn-outline-primary',
          icon: 'bx bx-printer',
        },
        {
          name: 'StartWarehouseHandling',
          className: 'btn-outline-primary',
          icon: 'fas fa-clipboard-list',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      '',
      []
    );

    if (this.endPoint != null) {
      this.action.title = this.endPoint;
    }
  }

  public endPoint: string = `WarehouseHandling`;

  public thisReport?: WarehouseHandlingReport;
  public data?: PCTableInputModel;
  public paging?: TabelPaging;
  public action: PCTableActionInputModel;
  public fields: any[] = [];
  public openAddModal: boolean = false;
  public modalDeleteConfirm: boolean = false;
  public modalLoading: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public breadCrumb: string = '';

  public requestModel: PCSearchRequestModel;
  public endPointUrl!: string;
  public loading: boolean = false;
  public activeWarehouseHandling: boolean = false;
  public thisValue: WarehouseHandlingModal;
  public stockList: any[] = [];

  public confirmModal: ModalConfirm = new ModalConfirm();
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild(WarehouseHandlingDetailComponent)
  warehouseHandlingDetailComponent!: WarehouseHandlingDetailComponent;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;

  @ViewChild('addModal') addModal!: NgbPopover;
  @ViewChild('reportModal') reportModal!: NgbPopover;

  @Output() outputParentAction = new EventEmitter<PCTableOutputModel>();
  public pageLoaded: boolean = true;
  public cardClass: string = 'animate__backInDown';

  public LoadPage() {
    this.InitPage();
    this.cardClass = 'animate__backInDown';
    this.pageLoaded = true;
    setTimeout(() => {
      this.cardClass = '';
    }, 2000);
  }

  public ClosePage() {
    this.cardClass = 'animate__backOutDown';
    setTimeout(() => {
      this.cardClass = '';
      this.pageLoaded = false;
    }, 1000);
  }

  public InitPage(): void {
    if (this.endPoint == null) {
      this.logger.addError('Endpoint is required .....!!!', false);
      return;
    }

    this.action.title = this.endPoint;
    this.generateUrl();
    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          this.logger.addResponseLog(this.endPointUrl, dataResult, `Get All`);
          if (dataResult.succeeded) {
            this.mapData(dataResult);
          }
        }

        if (entityResult) {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            entityResult,
            `Get Entity`
          );
          if (entityResult.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);

        setTimeout(() => {
          let selectStockPage = document.getElementById('selectStockPage');
          if (selectStockPage) {
            selectStockPage.classList.remove('animate__backInDown');
          }
        }, 2000);

        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      }
    );
  }

  private mapData(dataResult) {
    let firstItemOnPage = dataResult.data?.firstItemOnPage || 1;

    if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount!=0) {
      this.requestModel.pageNumber = 1;
      this.getSingleData();
    }

    this.data = new PCTableInputModel(
      dataResult.data?.items.map((current) => ({
        id: current.id,
        endDate: current.endDate,
        stockId: current.stockId,
        startDate: current.startDate,
        stockName: current.stockName,
        isActive: current.endDate == null ? true : false,
        noActiveId: current.endDate == null ? false : true,
      })),
      [
        {
          name: 'Report',
          className: 'btn-outline-primary',
          icon: 'far fa-comment-dots',
          condition: 'noActiveId',
        },
        {
          name: 'WarehouseHandling',
          className: 'btn-outline-primary',
          icon: 'fas fa-clipboard-list',
          condition: 'isActive',
        },
        {
          name: 'FastWarehousingHandling',
          className: 'btn-outline-primary',
          icon: 'fas fa-shipping-fast',
          condition: 'isActive',
        },
      ],
      true,
      firstItemOnPage,
      this.requestModel.orderBy,
      this.requestModel.direction
    );

    this.paging = this.responseService.customizePaging(dataResult);

    setTimeout(() => {
      this.setTableButtonWithPermission();
    }, 200);
  }

  private setTableButtonWithPermission() {
    try {
      let permissions = this.database.getData('ButtonPermission');
      if (permissions == null || permissions.length == 0) {
        return;
      }
      let pagePermission = permissions.find(
        (current) => current.viewName == 'InventoryReconciliation'
      );
      if (pagePermission == null) return;

      let reconciliation = new PCTableRowButtonModel(
        pagePermission.viewName,
        'btn-outline-warning',
        pagePermission.icon
      );
      reconciliation.condition = 'isActive';
      reconciliation.redirectUrl = pagePermission.urlField;

      this.data?.rowButtoms.push(reconciliation);
    } catch (error) {
      this.logger.addError('Fetch_Permission_Error', false);
    }
  }

  public getData() {
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getSingleData() {
    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
            if (result.succeeded) {
              this.mapData(result);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          this.endPoint
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public getStockData() {
    try {
      this.loading = true;
      let url = `Stock?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.stockList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.title,
              persianName: current.title,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  private getListElements(url, item, fieldName) {
    url = `${url}?pageNumber=1&pageSize=100000&paging=false&orderBy=&direction=asc`;
    this.apiService.getWitoutPage(new ApiRequestModel(`${url}`)).subscribe(
      (result) => {
        this.logger.addResponseLog(url == null ? '' : url, result, `getAll`);
        if (result.succeeded) {
          if (fieldName == undefined) {
            item.dropDownValue = result.data?.map((current) => ({
              id: current.id,
              friendlyName: current.persianName,
            }));
          } else {
            item.dropDownValue = result.data?.map((current) => ({
              id: current.id,
              friendlyName: current[fieldName],
            }));
          }
        } else {
          this.logger.addBackEndMessage(result);
        }
      },
      (error) => {
        this.apiService.AddErrorLog(error);
      },
      () => {}
    );
  }

  public generateUrl() {
    this.endPointUrl = `${this.endPoint}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public submitAdd() {
    try {
      this.loading = true;

      var backendJson = {
        stockId: this.thisValue.stockId,
        startDate: new Date().toISOString(),
      };

      this.apiService
        .postItem(new ApiRequestModel(this.endPoint, backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.modalService.dismissAll();
              this.modalSuccessConfirm = true;
              const eventItem: PCTableOutputModel = new PCTableOutputModel(
                'WarehouseHandling',
                result.data
              );
              this.outputParentAction.next(eventItem);
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.loading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
            console.log(`Completed!`);
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public submitDelete() {
    try {
      this.loading = true;
      let url = `${this.endPoint}/${this.thisValue.id}`;

      this.apiService.deleteItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Delete`);
          if (result.succeeded) {
            this.getSingleData();
            this.modalSuccessConfirm = true;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public createJson(inputElement) {
    var backentJson = {};
    for (let index = 0; index < inputElement.length; index++) {
      const element = inputElement[index];
      let exactMatch = new RegExp(`ArrayList`);
      if (element.fieldDatatype.match(exactMatch) != null) {
        backentJson[element.fieldName] = [];
        if (typeof element.defValue == 'string') {
          backentJson[element.fieldName].push(element.defValue);
        } else if (element.defValue instanceof Array) {
          for (let index = 0; index < element.defValue.length; index++) {
            const defelement = element.defValue[index];
            backentJson[element.fieldName].push(defelement);
          }
        }

        continue;
      }

      exactMatch = new RegExp(`Enum`);
      if (
        element.fieldDatatype.match(exactMatch) != null &&
        element.defValue == ``
      ) {
        backentJson[element.fieldName] = null;
        continue;
      }

      if (element.defValue != null && typeof element.defValue == 'string') {
        exactMatch = new RegExp(`double`);
        if (element.defValue.match(exactMatch) != null) {
          backentJson[element.fieldName] = 0;
          continue;
        }
      }

      if (element.defValue == null && element.fieldDatatype == 'boolean') {
        backentJson[element.fieldName] = false;
        continue;
      }

      if (element.fieldDatatype == 'TimeSpan') {
        backentJson[element.fieldName] = this.changeTime(element.defValue);
        continue;
      }

      backentJson[element.fieldName] = element.defValue;
    }

    return backentJson;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        }

        this.requestModel.orderBy = event.data;

        this.generateUrl();
        this.getSingleData();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Paging':
        this.loading = true;

        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'StartWarehouseHandling':
        this.openAddModal = true;
        this.openModal(this.addModal);
        break;
      case 'Close':
        this.thisValue = new WarehouseHandlingModal();
        this.openAddModal = false;
        break;
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'WarehouseHandling':
        this.outputParentAction.next(event);
        break;
      case 'FastWarehousingHandling':
        this.outputParentAction.next(event);
        break;
      case 'Return':
        this.thisValue = new WarehouseHandlingModal();
        this.openPage();
        break;
      case 'Report':
        this.thisValue = event.data;
        this.openReportModal();
        break;
      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;
      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;

      case 'InventoryReconciliation':
        this.database.setData(event.data, 'ReconciliationData');
        this.route.navigate(['InventoryReconciliation']);
        break;
      default:
        break;
    }
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
            setTimeout(() => {
              this.openAddModal = false;
            }, 1 * 1000);
          },
          (reason) => {
            setTimeout(() => {
              this.openAddModal = false;
            }, 1 * 1000);
          }
        );
    } catch (error) {}
  }

  public changeTime(value: any): string | null {
    var timeArray = value.split(':');
    var date = new Date();
    date.setHours(timeArray[0]);
    date.setMinutes(timeArray[1]);
    date.setSeconds(0);

    return this.datepipe.transform(date, 'HH:mm:ss');
  }

  private openPage() {
    this.getSingleData();

    var leaveElement = document.getElementById(
      'warehouse-handling-detail-page'
    );

    if (leaveElement == null) {
      return;
    }

    leaveElement.classList.remove('animate__backInDown');
    leaveElement.classList.add('animate__backOutDown');

    setTimeout(() => {
      this.activeWarehouseHandling = false;
    }, 700);
  }

  private openReportModal() {
    try {
      this.loading = true;
      this.thisReport = undefined;
      if (this.thisValue == undefined) {
        this.logger.addError('خطا نا شناخته رخ داده است ', false);
        return;
      }

      const thisUrl = `WarehouseHandling/Report/${this.thisValue.id}`;

      this.apiService.getSingleItem(new ApiRequestModel(thisUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            result,
            `getAll`
          );
          if (result.succeeded) {
            this.thisReport = result.data;
            this.openModal(this.reportModal);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
    }
  }
}
